import { render, staticRenderFns } from "./BuildingDetailsForm.vue?vue&type=template&id=4b708fb8"
import script from "./BuildingDetailsForm.vue?vue&type=script&lang=js"
export * from "./BuildingDetailsForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports